export default __webpack_public_path__ + "static/media/tree-deciduous.5b242162.svg";